import { useGetById } from './useGetById'
import { useGetByIds } from './useGetByIds'
import {
  useGetMine,
  useGetMineByProgramInstance,
  useGetMineByProgramInstanceWithInfiniteQuery,
  useGetMineWithInfiniteQuery,
} from './useGetMine'

export const tasksReview = {
  getById: useGetById,
  mine: useGetMine,
  mineByProgramInstance: useGetMineByProgramInstance,
  mineInfinite: useGetMineWithInfiniteQuery,
  mineByProgramInstanceInfinite: useGetMineByProgramInstanceWithInfiniteQuery,
  mineIds: useGetByIds,
}
